import styled from "styled-components";

export const ImageCopyrightWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  h2 {
    font-weight: bold;
    font-size: 14px;
    line-height: 24px;
    text-transform: uppercase;
    margin: 12px 0;
  }
`;

export const Scroll = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1;
`;
